import { useState } from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import Eye from '@jda/lui-common-icon-library-mui5/ui/Eye';
import EyeOff from '@jda/lui-common-icon-library-mui5/ui/EyeOff';
import Copy from '@jda/lui-common-icon-library-mui5/ui/Copy';
import CopyToClipboard from 'react-copy-to-clipboard';
import {
  CLIENT_SECRET_PARAGRAPH,
  SHOW_CLIENT_SECRET,
  HIDE_CLIENT_SECRET,
  COPY_TO_CLIPBOARD,
  CLIENT_SECRET_COPY_SUCCESS_MESSAGE
} from './constants';
import { useStyles } from './styles';

interface IMachineSecretCopyDialogProps {
  secretText: string;
  displaySnackbar: Function
  setCopyClicked?: Function
}
const MachineSecretCopyDialog = ({ secretText, displaySnackbar, setCopyClicked }: IMachineSecretCopyDialogProps) => {
  const { classes } = useStyles();
  const [showHideSecret, setShowHideSecret] = useState(false);


  const showHideSecretTextHandler = () => {
    if (showHideSecret) {
      return secretText;
    } else {
      return `${secretText.substring(0, 3)}*************************`;
    }
  };

  const showSecret = () => {
    setShowHideSecret(true);
  };

  const hideSecret = () => {
    setShowHideSecret(false);
  };

  return (
    <Box>
      {/* <Typography
        data-testid="display-client-secret-text"
        component="p"
        gutterBottom
        variant="body1"
        className={classes.fontWeightBold}
      >
        {CLIENT_SECRET_TEXT}
      </Typography> */}
      <Typography
        data-testid="display-client-secret-paragraph"
        component="p"
        gutterBottom
        variant="body1"
        className={classes.styler}
      >
        {CLIENT_SECRET_PARAGRAPH}
      </Typography>
      <Box className={classes.iconBox}>
      <Typography
        data-testid="display-client-secret-text-handler"
        component="p"
        gutterBottom
        variant="body1"
        className={classes.divider}
        id="text"
      >
        {showHideSecretTextHandler()}
      </Typography>
        <Tooltip
          id="show-hide-tooltip"
          arrow
          title={showHideSecret ? HIDE_CLIENT_SECRET : SHOW_CLIENT_SECRET}
          placement="bottom"
        >
          <span className={classes.iconAlignment}>
            {showHideSecret ? (
              <EyeOff id="client-secret-eye-off" data-testid="client-secret-eye-off" onClick={hideSecret} />
            ) : (
              <Eye id="client-secret-eye" data-testid="client-secret-eye" onClick={showSecret} />
            )}
          </span>
        </Tooltip>
        <Tooltip
          id="copy-tooltip"
          arrow
          title={COPY_TO_CLIPBOARD}
          placement="top"
          className={classes.iconAlignment}
        >
          <div>
            <CopyToClipboard
              text={secretText}
              data-testid="copy-to-clipboard"
              onCopy={() => {
                setCopyClicked && setCopyClicked(true);
                displaySnackbar(CLIENT_SECRET_COPY_SUCCESS_MESSAGE, 'success')
              }}
            >
              <Copy id="client-secret-copy" data-testid="client-secret-copy" />
            </CopyToClipboard>
          </div>
        </Tooltip>
      </Box>
    </Box>
  )
};

export default MachineSecretCopyDialog;